/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const ESGDocumentAPI = async (
  year: string = '',
  framework: string = '',
  documentType: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  if (!year || !framework || !documentType) {
    return [];
  }

  try {
    const response = await axios.request({
      method: 'GET',
      // eslint-disable-next-line max-len
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.AIDocumentManager}/esg/${companyID}/${year}/${framework}/${documentType}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response.data.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default ESGDocumentAPI;
